export default __webpack_public_path__ + "static/google_Desktop9-b5771c7be09b1269c1fb61474aefb2da.svg";